import { useEffect, useState } from "react";

import FirebaseService from "../actions/firebase/FirebaseActions";
import { FirebaseSnapshotMapper } from "../actions/firebase/FirebaseSnapshotMapper";
import { UserDefaultForm } from "../models/userDefaultForm/UserDefaultForm";

export const useUserDefaultForm = (userId: string): [UserDefaultForm | undefined, boolean] => {
  const [defaultForm, setDefaultForm] = useState<UserDefaultForm>();
  const [isLoading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!userId) return;

    return FirebaseService.streamUserDefaultForm(userId, {
      next: (doc) => {
        setDefaultForm(FirebaseSnapshotMapper.toUserDefaultForm(doc));
        setLoading(false);
      },
      error: () => {
        // No document found → Fallback to 1:1 mapping
        setDefaultForm({
          id: userId,
          formOwnerId: userId
        });
        setLoading(false);
      }
    });
  }, [userId]);

  return [defaultForm, isLoading];
};
